<template>
  <div>
    <v-data-table
      v-model:expanded="expanded"
      item-key="action"
      :headers="headers"
      :items="data"
      :loading="loading"
      loading-text="Загрузка..."
      sort-by="count"
      class="elevation-1"
      :items-per-page="-1"
      hide-default-footer
      height="calc(100vh - 123px)"
      show-expand
    >
      <template v-slot:expanded-item="{ item }">
        <td :colspan="4" class="pa-0">
          <v-data-table
            class="grey pl-14"
            :headers="supportIdCountsHeaders"
            :items="item.supportIdCounts"
            :items-per-page="-1"
            hide-default-footer
          >
            <template v-slot:item.supportId="{ item }">
              <span>{{
                getSupportByAzureId(item.supportId)?.nickname || item.supportId
              }}</span>
            </template>
          </v-data-table>
        </td>
      </template>

      <template v-slot:item.action="{ item }">
        <span>{{ getActionLabel(item.action) }}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CHAT_ACTIONS_MAP } from '@/models/actions';
import { DEPARTMENT } from '@/models/departments';

const ALL_CHAT_ACTIONS = [
  ...CHAT_ACTIONS_MAP[DEPARTMENT.REGISTER],
  ...CHAT_ACTIONS_MAP[DEPARTMENT.FINANCES],
];

export default {
  name: 'ActionAggregatesTable',

  props: {
    data: Array,
    loading: Boolean,
  },

  data() {
    return {
      actions: ALL_CHAT_ACTIONS,
      headers: [
        {
          text: 'Действие',
          value: 'action',
          width: 500,
          sortable: false,
          cellClass: 'font-weight-bold',
        },
        { text: 'Количество', value: 'total' },
      ],
      supportIdCountsHeaders: [
        { text: 'Саппорт', value: 'supportId', width: 400 },
        { text: 'Количество', value: 'count' },
      ],
      expanded: [],
    };
  },

  computed: {
    ...mapGetters('adminSupport', {
      getSupportByAzureId: 'getSupportByAzureId',
    }),
  },

  methods: {
    getActionLabel(action) {
      const actionLabel = this.actions.find(
        ({ value }) => value === action
      )?.text;

      return actionLabel || action;
    },
  },
};
</script>
